import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { DataSourceValidationBase } from "abweb/dto/generated/ds/DataSourceValidationBase";
export class DataSourceValidation extends DataSourceValidationBase {
  static createDataSourceValidation(dateRangeMax, dateRangeMin, expression, isWarning, maxLength, numDecimalPlaces, patternMatch, patternMatchDisplayMessage, patternMatchFlags, rangeMax, rangeMin, validValues) {
    const retVal = new DataSourceValidation();
    retVal.initDataSourceValidation(dateRangeMax, dateRangeMin, expression, isWarning, maxLength, numDecimalPlaces, patternMatch, patternMatchDisplayMessage, patternMatchFlags, rangeMax, rangeMin, validValues);
    if (patternMatch != null) {
      // We have a RegExp that we should compile now.  Also, flags argument to RegExp constructor must be string|undefined, not string|null.
      retVal.regExp = new RegExp(patternMatch, patternMatchFlags == null ? undefined : patternMatchFlags);
    }
    return retVal;
  }
  constructor() {
    super();
    _defineProperty(this, "regExp", null);
  }
}
//# sourceMappingURL=DataSourceValidation.js.map
